export default __webpack_public_path__ + "static/media/panelData6.b8bdf0c1.jpg";